'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Field = require('../Field/Field');

var _Field2 = _interopRequireDefault(_Field);

var _constants = require('../../shared/constants');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DATE_FORMAT = 'MMMM Do YYYY';

var _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.focus = function () {
            if (_this.field) {
                _this.field.focus();
            }
        }, _this._valueToLabel = function (value) {
            var _this$props = _this.props,
                locale = _this$props.locale,
                timezone = _this$props.timezone,
                format = _this$props.format;

            var date = _momentTimezone2.default.tz(value, timezone).locale(locale);
            return _react2.default.createElement(
                'time',
                { 'aria-label': date.format(DATE_FORMAT) },
                date.format(format)
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _class.prototype.componentWillMount = function componentWillMount() {
        if (this.props.locale) {
            _momentTimezone2.default.locale(this.props.locale);
        }
        if (this.props.timezone) {
            _momentTimezone2.default.tz.setDefault(this.props.timezone);
        }
    };

    _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        var defaultValue = 'defaultValue';
        var value = 'value';
        var functionKeys = [].concat(_lodash2.default.functions(nextProps), [_lodash2.default.functions(this.props)]);
        var omitKeys = [].concat(functionKeys, [defaultValue, value]);

        if (!(0, _momentTimezone2.default)(nextProps[defaultValue]).isSame(this.props[defaultValue], 'day')) {
            return true;
        }

        if (!(0, _momentTimezone2.default)(nextProps[value]).isSame(this.props[value], 'day')) {
            return true;
        }

        for (var i = 0; i < functionKeys.length; i++) {
            var key = functionKeys[i];
            var nextProp = nextProps[key];
            var thisProp = this.props[key];
            if ('' + nextProp !== '' + thisProp) {
                return true;
            }
        }

        return !_lodash2.default.isEqual(_lodash2.default.omit(nextProps, omitKeys), _lodash2.default.omit(this.props, omitKeys));
    };

    _class.prototype.render = function render() {
        var _this2 = this;

        var props = _extends({}, this.props);
        props.type = _constants.COMPONENT_TYPES.DATE_PICKER_TYPE;
        props.data = props.options;
        props.valueToLabel = this._valueToLabel;
        props.value = props.value || null;

        return _react2.default.createElement(_Field2.default, _extends({ ref: function ref(el) {
                return _this2.field = el;
            } }, props));
    };

    return _class;
}(_react2.default.Component);

_class.defaultProps = {
    format: DATE_FORMAT
};
exports.default = _class;